'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { NavigationSection } from '@qogita/ui/v2/navigation'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

/**
 * A navigation section that is active if the current path starts with the subpath
 */
export function ActiveNavigationSection({
  subpath,
  children,
}: {
  /** The subpath to check if the current path includes it */
  subpath: string
  children: ReactNode
}) {
  const pathname = usePathname()
  const isActive = pathname?.startsWith(subpath) ?? false

  return <NavigationSection isActive={isActive}>{children}</NavigationSection>
}
